<form [formGroup]="loanProductAccountingForm">
  <div class="layout-row-wrap gap-2px responsive-column">
    <mat-radio-group
      class="flex-98 layout-row gap-5percent layout-lt-md-column radio-group-spacing"
      formControlName="accountingRule"
    >
      @for (accountingRule of accountingRuleData; track accountingRule; let i = $index) {
        <mat-radio-button [value]="i + 1">
          {{ 'labels.accounting.' + accountingRule | translate }}
        </mat-radio-button>
      }
    </mat-radio-group>

    <mat-divider class="flex-98"></mat-divider>

    @if (loanProductAccountingForm.value.accountingRule >= 2 && loanProductAccountingForm.value.accountingRule <= 4) {
      <div class="flex-100 layout-row-wrap responsive-column">
        @if (isAccountingAccrualBased) {
          <mat-checkbox class="flex-73" formControlName="enableAccrualActivityPosting">{{
            'labels.inputs.Enable Accrual Activity Posting on Installment Due Date' | translate
          }}</mat-checkbox>
        }
        <h4 class="mat-h4 flex-98">
          {{ 'labels.heading.Assets' | translate }} / {{ 'labels.heading.Liabilities' | translate }}
        </h4>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.fundSourceAccountId"
          [glAccountList]="assetAndLiabilityAccountData"
          [required]="true"
          [inputLabel]="'Fund source'"
        >
        </LOSx-gl-account-selector>
        <h4 class="mat-h4 flex-98">{{ 'labels.heading.Assets' | translate }}</h4>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.loanPortfolioAccountId"
          [glAccountList]="assetAccountData"
          [required]="true"
          [inputLabel]="'Loan portfolio'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.transfersInSuspenseAccountId"
          [glAccountList]="assetAccountData"
          [required]="true"
          [inputLabel]="'Transfer in suspense'"
        >
        </LOSx-gl-account-selector>
        @if (
          loanProductAccountingForm.value.accountingRule === 3 || loanProductAccountingForm.value.accountingRule === 4
        ) {
          <div class="flex-100 layout-row-wrap responsive-column">
            <LOSx-gl-account-selector
              class="flex-48"
              [inputFormControl]="loanProductAccountingForm.controls.receivableInterestAccountId"
              [glAccountList]="assetAccountData"
              [required]="true"
              [inputLabel]="'Interest Receivable'"
            >
            </LOSx-gl-account-selector>
            <LOSx-gl-account-selector
              class="flex-48"
              [inputFormControl]="loanProductAccountingForm.controls.receivableFeeAccountId"
              [glAccountList]="assetAccountData"
              [required]="true"
              [inputLabel]="'Fees Receivable'"
            >
            </LOSx-gl-account-selector>
            <LOSx-gl-account-selector
              class="flex-48"
              [inputFormControl]="loanProductAccountingForm.controls.receivablePenaltyAccountId"
              [glAccountList]="assetAccountData"
              [required]="true"
              [inputLabel]="'Penalties Receivable'"
            >
            </LOSx-gl-account-selector>
          </div>
        }
        <mat-divider class="flex-98"></mat-divider>
        <h4 class="mat-h4 flex-98">{{ 'labels.heading.Income' | translate }}</h4>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.interestOnLoanAccountId"
          [glAccountList]="incomeAccountData"
          [required]="true"
          [inputLabel]="'Income from Interest'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.incomeFromFeeAccountId"
          [glAccountList]="incomeAccountData"
          [required]="true"
          [inputLabel]="'Income from fees'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.incomeFromPenaltyAccountId"
          [glAccountList]="incomeAccountData"
          [required]="true"
          [inputLabel]="'Income from penalties'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.incomeFromRecoveryAccountId"
          [glAccountList]="incomeAccountData"
          [required]="true"
          [inputLabel]="'Income from Recovery Repayments'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.incomeFromChargeOffInterestAccountId"
          [glAccountList]="incomeAccountData"
          [required]="true"
          [inputLabel]="'Income from ChargeOff Interest'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.incomeFromChargeOffFeesAccountId"
          [glAccountList]="incomeAccountData"
          [required]="true"
          [inputLabel]="'Income from ChargeOff Fees'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.incomeFromChargeOffPenaltyAccountId"
          [glAccountList]="incomeAccountData"
          [required]="true"
          [inputLabel]="'Income from ChargeOff Penalty'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.incomeFromGoodwillCreditInterestAccountId"
          [glAccountList]="incomeAccountData"
          [required]="true"
          [inputLabel]="'Income from Goodwill Credit Interest'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.incomeFromGoodwillCreditFeesAccountId"
          [glAccountList]="incomeAccountData"
          [required]="true"
          [inputLabel]="'Income from Goodwill Credit Fees'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.incomeFromGoodwillCreditPenaltyAccountId"
          [glAccountList]="incomeAccountData"
          [required]="true"
          [inputLabel]="'Income from Goodwill Credit Penalty'"
        >
        </LOSx-gl-account-selector>
        @if (deferredIncomeRecognition?.capitalizedIncome?.enableIncomeCapitalization) {
          <LOSx-gl-account-selector
            class="flex-48"
            [inputFormControl]="loanProductAccountingForm.controls.incomeFromCapitalizationAccountId"
            [glAccountList]="incomeAccountData"
            [required]="true"
            [inputLabel]="'Income capitalization'"
          >
          </LOSx-gl-account-selector>
        }
        @if (deferredIncomeRecognition?.buyDownFee?.enableBuyDownFee) {
          <LOSx-gl-account-selector
            class="flex-48"
            [inputFormControl]="loanProductAccountingForm.controls.incomeFromBuyDownAccountId"
            [glAccountList]="incomeAccountData"
            [required]="true"
            [inputLabel]="'Income from Buy down fees'"
          >
          </LOSx-gl-account-selector>
        }
        <mat-divider class="flex-98"></mat-divider>
        <h4 class="mat-h4 flex-98">{{ 'labels.heading.Expenses' | translate }}</h4>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.writeOffAccountId"
          [glAccountList]="expenseAccountData"
          [required]="true"
          [inputLabel]="'Losses written off'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.goodwillCreditAccountId"
          [glAccountList]="expenseAccountData"
          [required]="true"
          [inputLabel]="'Expenses from Goodwill Credit'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.chargeOffExpenseAccountId"
          [glAccountList]="expenseAccountData"
          [required]="true"
          [inputLabel]="'ChargeOff Expense'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.chargeOffFraudExpenseAccountId"
          [glAccountList]="expenseAccountData"
          [required]="true"
          [inputLabel]="'ChargeOff Fraud Expense'"
        >
        </LOSx-gl-account-selector>
        @if (
          deferredIncomeRecognition?.buyDownFee?.enableBuyDownFee &&
          deferredIncomeRecognition?.buyDownFee?.merchantBuyDownFee
        ) {
          <LOSx-gl-account-selector
            class="flex-48"
            [inputFormControl]="loanProductAccountingForm.controls.buyDownExpenseAccountId"
            [glAccountList]="expenseAccountData"
            [required]="true"
            [inputLabel]="'Buy down fee Expense'"
          >
          </LOSx-gl-account-selector>
        }
        <mat-divider class="flex-98"></mat-divider>
        <h4 class="mat-h4 flex-98">{{ 'labels.heading.Liabilities' | translate }}</h4>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="loanProductAccountingForm.controls.overpaymentLiabilityAccountId"
          [glAccountList]="liabilityAccountData"
          [required]="true"
          [inputLabel]="'Over payment liability'"
        >
        </LOSx-gl-account-selector>
        @if (
          deferredIncomeRecognition?.capitalizedIncome?.enableIncomeCapitalization ||
          deferredIncomeRecognition?.buyDownFee?.enableBuyDownFee
        ) {
          <LOSx-gl-account-selector
            class="flex-48"
            [inputFormControl]="loanProductAccountingForm.controls.deferredIncomeLiabilityAccountId"
            [glAccountList]="liabilityAccountData"
            [required]="true"
            [inputLabel]="'Deferred income'"
          >
          </LOSx-gl-account-selector>
        }
        <mat-divider fxFlex="flex-98"></mat-divider>
        <mat-checkbox class="flex-73" formControlName="advancedAccountingRules">{{
          'labels.heading.Advanced Accounting Rules' | translate
        }}</mat-checkbox>
        @if (loanProductAccountingForm.value.advancedAccountingRules) {
          <div class="flex-100 layout-row-wrap responsive-column">
            <h4 class="mat-h4 flex-33">
              {{ 'labels.heading.Configure Fund Sources for Payment Channels' | translate }}
            </h4>
            <div class="flex-63">
              <button
                type="button"
                mat-raised-button
                color="primary"
                (click)="add('PaymentFundSource', paymentChannelToFundSourceMappings)"
              >
                <fa-icon icon="plus" class="m-r-10"></fa-icon>
                {{ 'labels.buttons.Add' | translate }}
              </button>
            </div>
            @if (paymentChannelToFundSourceMappings.value.length !== 0) {
              <table class="flex-98 mat-elevation-z1" mat-table [dataSource]="paymentChannelToFundSourceMappings.value">
                <ng-container matColumnDef="paymentTypeId">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Payment Type' | translate }}</th>
                  <td mat-cell *matCellDef="let paymentFundSource">
                    {{ paymentFundSource.paymentTypeId | find: paymentTypeData : 'id' : 'name' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="fundSourceAccountId">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Fund Source' | translate }}</th>
                  <td mat-cell *matCellDef="let paymentFundSource">
                    {{ paymentFundSource.fundSourceAccountId | find: assetAccountData : 'id' : 'name' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
                  <td mat-cell *matCellDef="let paymentFundSource; let i = index">
                    <button
                      mat-icon-button
                      color="primary"
                      (click)="edit('PaymentFundSource', paymentChannelToFundSourceMappings, i)"
                    >
                      <fa-icon icon="edit"></fa-icon>
                    </button>
                    <button
                      mat-icon-button
                      color="warn"
                      (click)="delete('PaymentFundSource', paymentChannelToFundSourceMappings, i)"
                    >
                      <fa-icon icon="trash"></fa-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="paymentFundSourceDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: paymentFundSourceDisplayedColumns"></tr>
              </table>
            }
            <h4 class="mat-h4 flex-33">{{ 'labels.heading.Map Fees to Specific Income Accounts' | translate }}</h4>
            <div class="flex-63">
              <button
                type="button"
                mat-raised-button
                color="primary"
                (click)="add('FeesIncome', feeToIncomeAccountMappings)"
              >
                <fa-icon icon="plus" class="m-r-10"></fa-icon>
                {{ 'labels.buttons.Add' | translate }}
              </button>
            </div>
            @if (feeToIncomeAccountMappings.value.length !== 0) {
              <table class="flex-98 mat-elevation-z1" mat-table [dataSource]="feeToIncomeAccountMappings.value">
                <ng-container matColumnDef="chargeId">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Fees' | translate }}</th>
                  <td mat-cell *matCellDef="let feesIncome">
                    {{ feesIncome.chargeId | find: chargeData : 'id' : 'name' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="incomeAccountId">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Income Account' | translate }}</th>
                  <td mat-cell *matCellDef="let feesIncome">
                    {{ feesIncome.incomeAccountId | find: incomeAndLiabilityAccountData : 'id' : 'name' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
                  <td mat-cell *matCellDef="let feesIncome; let i = index">
                    <button mat-icon-button color="primary" (click)="edit('FeesIncome', feeToIncomeAccountMappings, i)">
                      <fa-icon icon="edit"></fa-icon>
                    </button>
                    <button mat-icon-button color="warn" (click)="delete('FeesIncome', feeToIncomeAccountMappings, i)">
                      <fa-icon icon="trash"></fa-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="feesPenaltyIncomeDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: feesPenaltyIncomeDisplayedColumns"></tr>
              </table>
            }
            <h4 class="mat-h4 flex-33">
              {{ 'labels.heading.Map Penalties to Specific Income Accounts' | translate }}
            </h4>
            <div class="flex-63">
              <button
                type="button"
                mat-raised-button
                color="primary"
                (click)="add('PenaltyIncome', penaltyToIncomeAccountMappings)"
              >
                <fa-icon icon="plus" class="m-r-10"></fa-icon>
                {{ 'labels.buttons.Add' | translate }}
              </button>
            </div>
            @if (penaltyToIncomeAccountMappings.value.length !== 0) {
              <table class="flex-98 mat-elevation-z1" mat-table [dataSource]="penaltyToIncomeAccountMappings.value">
                <ng-container matColumnDef="chargeId">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Penalty' | translate }}</th>
                  <td mat-cell *matCellDef="let penaltyIncome">
                    {{ penaltyIncome.chargeId | find: penaltyData : 'id' : 'name' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="incomeAccountId">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Income Account' | translate }}</th>
                  <td mat-cell *matCellDef="let penaltyIncome">
                    {{ penaltyIncome.incomeAccountId | find: incomeAccountData : 'id' : 'name' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
                  <td mat-cell *matCellDef="let penaltyIncome; let i = index">
                    <button
                      mat-icon-button
                      color="primary"
                      (click)="edit('PenaltyIncome', penaltyToIncomeAccountMappings, i)"
                    >
                      <fa-icon icon="edit"></fa-icon>
                    </button>
                    <button
                      mat-icon-button
                      color="warn"
                      (click)="delete('PenaltyIncome', penaltyToIncomeAccountMappings, i)"
                    >
                      <fa-icon icon="trash"></fa-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="feesPenaltyIncomeDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: feesPenaltyIncomeDisplayedColumns"></tr>
              </table>
            }
            <h4 class="mat-h4 flex-33">
              {{ 'labels.heading.Map Charge-off reasons to Expense accounts' | translate }}
            </h4>
            <div class="flex-63">
              <button
                type="button"
                mat-raised-button
                color="primary"
                [disabled]="!allowAddChargeOffReasonExpense"
                (click)="add('ChargeOffReasonExpense', chargeOffReasonToExpenseAccountMappings)"
              >
                <fa-icon icon="plus" class="m-r-10"></fa-icon>
                {{ 'labels.buttons.Add' | translate }}
              </button>
            </div>
            @if (chargeOffReasonToExpenseAccountMappings.value.length !== 0) {
              <table
                class="flex-98 mat-elevation-z1"
                mat-table
                [dataSource]="chargeOffReasonToExpenseAccountMappings.value"
              >
                <ng-container matColumnDef="chargeOffReasonCodeValueId">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Charge-off reason' | translate }}</th>
                  <td mat-cell *matCellDef="let chargeOffReasonExpense">
                    {{
                      chargeOffReasonExpense.chargeOffReasonCodeValueId | find: chargeOffReasonOptions : 'id' : 'name'
                    }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="expenseAccountId">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Expense Account' | translate }}</th>
                  <td mat-cell *matCellDef="let chargeOffReasonExpense">
                    {{ chargeOffReasonExpense.expenseAccountId | find: expenseAccountData : 'id' : 'name' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
                  <td mat-cell *matCellDef="let chargeOffReasonExpense; let i = index">
                    <button
                      mat-icon-button
                      color="primary"
                      (click)="edit('ChargeOffReasonExpense', chargeOffReasonToExpenseAccountMappings, i)"
                    >
                      <fa-icon icon="edit"></fa-icon>
                    </button>
                    <button
                      mat-icon-button
                      color="warn"
                      (click)="delete('ChargeOffReasonExpense', chargeOffReasonToExpenseAccountMappings, i)"
                    >
                      <fa-icon icon="trash"></fa-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="chargeOffReasonExpenseDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: chargeOffReasonExpenseDisplayedColumns"></tr>
              </table>
            }
            <LOSx-advanced-accounting-mapping-rule
              class="flex-100 m-t-10"
              [textField]="'Classification'"
              [formType]="'BuydownFeeClassificationToIncome'"
              [formArray]="buydownfeeClassificationToIncomeAccountMappings"
              [textHeading]="'Buydown Fee classifications to Income accounts'"
              [incomeAccountData]="incomeAccountData"
              [accountingMappingOptions]="buydownFeeClassificationOptions"
              (formChangeEvent)="formChangeEvent($event)"
            ></LOSx-advanced-accounting-mapping-rule>
            <LOSx-advanced-accounting-mapping-rule
              class="flex-100 m-t-10"
              [textField]="'Classification'"
              [formType]="'CapitalizedIncomeClassificationToIncome'"
              [formArray]="capitalizedIncomeClassificationToIncomeAccountMappings"
              [textHeading]="'Capitalized Income classifications to Income accounts'"
              [incomeAccountData]="incomeAccountData"
              [accountingMappingOptions]="capitalizedIncomeClassificationOptions"
              (formChangeEvent)="formChangeEvent($event)"
            ></LOSx-advanced-accounting-mapping-rule>
            <LOSx-advanced-accounting-mapping-rule
              class="flex-100 m-t-10"
              [textField]="'WriteOff Reason'"
              [formType]="'WriteOffReasonToExpense'"
              [formArray]="writeOffReasonsToExpenseMappings"
              [textHeading]="'WriteOff reasons to Expense accounts'"
              [expenseAccountData]="expenseAccountData"
              [accountingMappingOptions]="writeOffReasonOptions"
              (formChangeEvent)="formChangeEvent($event)"
            ></LOSx-advanced-accounting-mapping-rule>
          </div>
        }
      </div>
    }
  </div>

  <div class="layout-row align-center margin-t responsive-column gap-2percent">
    <button mat-raised-button matStepperPrevious>
      <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Previous' | translate }}
    </button>
    <button mat-raised-button matStepperNext [disabled]="!loanProductFormValid">
      {{ 'labels.buttons.Next' | translate }}
      <fa-icon icon="arrow-right" class="m-l-10"></fa-icon>
    </button>
  </div>
</form>
